var map = {
	"./1sb-alert-blue.svg": 579,
	"./1sb-alert-boutique.svg": 580,
	"./1sb-dropdown-black.svg": 525,
	"./1sb-dropdown.svg": 512,
	"./1sb-five-stars-boutique-star-selected.svg": 772,
	"./1sb-five-stars-boutique-star-unselected.svg": 773,
	"./1sb-five-stars-orange-star-selected-boutique.svg": 621,
	"./1sb-five-stars-orange-star-selected.svg": 532,
	"./1sb-five-stars-orange-star-unselected-boutique.svg": 622,
	"./1sb-five-stars-orange-star-unselected.svg": 533,
	"./1sb-loader-icon.svg": 644,
	"./1sb-selected-star.svg": 638,
	"./1sb-tag-icon.svg": 519,
	"./1sb-unselected-star.svg": 639,
	"./1sb_100_night_img.svg": 623,
	"./1sb_Serta_sheep_img.svg": 624,
	"./1sb_Serta_sheep_img_mob.svg": 625,
	"./1sb_cloud_img.svg": 626,
	"./1sb_customer_review_icon.svg": 774,
	"./1sb_mini_logo_boutique.svg": 775,
	"./1sb_mini_logo_white.svg": 581,
	"./1sb_serta_with_sheep_logo_desk_v3.svg": 653,
	"./1sb_serta_with_sheep_logo_mob.svg": 654,
	"./1sb_serta_with_sheep_logo_mob_v1.svg": 655,
	"./BoutiquePopupLogo.svg": 656,
	"./BoutiquePopupLogoMobile.svg": 657,
	"./Mail_80x80.svg": 591,
	"./Mail_boutique_80x80.svg": 592,
	"./animation/icon-sb-buy-as-a-set-and-save-48x48.svg": 776,
	"./animation/icon-sb-shop-the-collection-48x48.svg": 777,
	"./animation/keen-slider-loader.svg": 582,
	"./back_arrow_v1.svg": 645,
	"./black_f_tag_d.svg": 778,
	"./black_friday_deal_text_d.svg": 779,
	"./black_friday_deal_text_d_plp.svg": 780,
	"./black_friday_deal_text_d_v1.svg": 781,
	"./black_friday_deal_text_m.svg": 782,
	"./black_friday_deal_text_m_plp.svg": 783,
	"./black_friday_deal_text_mob_v2.svg": 784,
	"./black_friday_deal_text_plp_d.svg": 785,
	"./black_friday_deal_text_v1.svg": 786,
	"./black_friday_deal_text_v2.svg": 787,
	"./buildyourown_desktop.svg": 788,
	"./buildyourown_mob.svg": 789,
	"./buildyourown_mob_v2.svg": 593,
	"./buildyourown_v2.svg": 790,
	"./buildyourown_v3.svg": 791,
	"./buildyourown_v5.svg": 594,
	"./checkbox_hover-black.svg": 792,
	"./checkbox_hover-gray-bg.svg": 646,
	"./checkbox_hover-gray-border.svg": 793,
	"./checkbox_hover.svg": 794,
	"./checkmark_green_v1.svg": 795,
	"./cms/icon-sb-checkmark-blue-color.svg": 658,
	"./cms/icon-sb-checkmark-white-color-16.svg": 659,
	"./cms/icon-sb-close-24.svg": 660,
	"./cms/icon-sb-link-arrow-red-color-16.svg": 89,
	"./coupon_text_desktop.svg": 796,
	"./dropdown-black.svg": 141,
	"./dropdown.svg": 124,
	"./errorPage.svg": 394,
	"./helpCenter/helpcenter_bg_v1.svg": 797,
	"./high_alert_v1.svg": 798,
	"./icon-best-value.svg": 534,
	"./icon-compare.svg": 799,
	"./icon-great-choice.svg": 535,
	"./icon-sb-1sb_Mini_logo-16x16.svg": 583,
	"./icon-sb-1sb_Mini_logo-boutique-16x16.svg": 584,
	"./icon-sb-Info-blue-color-16.svg": 526,
	"./icon-sb-Info-boutique-16.svg": 547,
	"./icon-sb-alert-red.svg": 800,
	"./icon-sb-black-friday-tag.svg": 801,
	"./icon-sb-brand-icon-v1.svg": 802,
	"./icon-sb-build-own-sectional-48x48.svg": 803,
	"./icon-sb-buy-as-a-set-and-save-48x48.svg": 595,
	"./icon-sb-buy-as-a-set-and-save-boutique-48x48.svg": 596,
	"./icon-sb-buy-now-160x106.svg": 573,
	"./icon-sb-buy-now-desktop.svg": 804,
	"./icon-sb-buy-now-mob.svg": 805,
	"./icon-sb-buy-now-tablet.svg": 806,
	"./icon-sb-buy-set-illustration-343x129.svg": 807,
	"./icon-sb-call-us-blue-color-48.svg": 574,
	"./icon-sb-call-us-boutique-color-48.svg": 575,
	"./icon-sb-carousel-arrow-right-black.svg": 597,
	"./icon-sb-carousel-arrow-right.svg": 567,
	"./icon-sb-checklist-illustration.svg": 647,
	"./icon-sb-checkmark-white-color-16.svg": 506,
	"./icon-sb-chevron-down-white-color.svg": 598,
	"./icon-sb-chevron-left-black-color-24.svg": 661,
	"./icon-sb-chevron-left-blue-color-24.svg": 662,
	"./icon-sb-chevron-left-cyan-color-24.svg": 663,
	"./icon-sb-chevron-left-gray-color-24.svg": 664,
	"./icon-sb-chevron-up-white-color.svg": 599,
	"./icon-sb-clock-orange-24x24.svg": 600,
	"./icon-sb-clock-orange-boutique-24x24.svg": 601,
	"./icon-sb-close-24.svg": 808,
	"./icon-sb-close-24_blue.svg": 665,
	"./icon-sb-coupon-color-48x48.svg": 602,
	"./icon-sb-coupon-color-48x48_v1.svg": 809,
	"./icon-sb-coupon-color-boutique-48x48.svg": 603,
	"./icon-sb-coupon-color-boutique-white-24x24.svg": 517,
	"./icon-sb-coupon-color-white-24x24.svg": 518,
	"./icon-sb-customize-this-set-48.svg": 548,
	"./icon-sb-customize-this-set-boutique-48x48.svg": 549,
	"./icon-sb-cyber-monday-tag.svg": 810,
	"./icon-sb-cyber-monday-tag_blue_v1.svg": 811,
	"./icon-sb-down-arrow-black.svg": 585,
	"./icon-sb-dropdown-arrow-20.svg": 514,
	"./icon-sb-dropdown-arrow-34.svg": 570,
	"./icon-sb-dropdown-arrow-black-20.svg": 515,
	"./icon-sb-dropdown-arrow-black-34.svg": 571,
	"./icon-sb-dropdown-arrow1-black-20.svg": 812,
	"./icon-sb-dropdown-white-10.svg": 627,
	"./icon-sb-forward-arrow.svg": 568,
	"./icon-sb-forward-arrow_boutique.svg": 569,
	"./icon-sb-hand-truck-blue-color-48.svg": 813,
	"./icon-sb-hand-truck-boutique-48.svg": 814,
	"./icon-sb-high-alert-color-80.svg": 586,
	"./icon-sb-katapult-logo.svg": 604,
	"./icon-sb-labor-day-bg.svg": 587,
	"./icon-sb-link-arrow-botique-color-16.svg": 550,
	"./icon-sb-link-arrow-red-color-16.svg": 513,
	"./icon-sb-link-bottom-arrow-red-color-16-v1.svg": 605,
	"./icon-sb-link-bottom-arrow-red-color-boutique-16x16.svg": 551,
	"./icon-sb-link-forward-arrow-red-color-16.svg": 606,
	"./icon-sb-logo-illustration.svg": 640,
	"./icon-sb-low-alert-orange-48x48.svg": 607,
	"./icon-sb-low-alert-orange-boutique-48x48.svg": 608,
	"./icon-sb-mattress-extra-firm-40_v1.svg": 552,
	"./icon-sb-mattress-extra-firm-boutique-40.svg": 553,
	"./icon-sb-mattress-firm-color-36.svg": 554,
	"./icon-sb-mattress-firm-color-boutique-36.svg": 555,
	"./icon-sb-mattress-medium-40.svg": 556,
	"./icon-sb-mattress-medium-boutique-40.svg": 557,
	"./icon-sb-mattress-next-arrow.svg": 628,
	"./icon-sb-mattress-next-arrow_boutique.svg": 629,
	"./icon-sb-mattress-plus-color-36.svg": 558,
	"./icon-sb-mattress-plus-color-boutique-36.svg": 559,
	"./icon-sb-mattress-prev-arrow.svg": 630,
	"./icon-sb-mattress-prev-arrow_boutique.svg": 631,
	"./icon-sb-mattress-returns-48.svg": 815,
	"./icon-sb-mattress-returns-boutique-48.svg": 816,
	"./icon-sb-mattress-ultra-plus-color-36.svg": 560,
	"./icon-sb-mattress-ultra-plus-color-boutique-36.svg": 561,
	"./icon-sb-minus.svg": 609,
	"./icon-sb-other-sectional-layouts-boutique_dektop.svg": 610,
	"./icon-sb-other-sectional-layouts-boutique_dektop_v1.svg": 611,
	"./icon-sb-other-sectional-layouts.svg": 612,
	"./icon-sb-other-sectional-layouts_v1.svg": 613,
	"./icon-sb-ottoman-recliner-48x48.svg": 562,
	"./icon-sb-ottoman-recliner.svg": 563,
	"./icon-sb-plus-12x12.svg": 614,
	"./icon-sb-recent-products-empty.svg": 615,
	"./icon-sb-returns-48.svg": 817,
	"./icon-sb-returns-boutique-48.svg": 818,
	"./icon-sb-shipping-truck-illustration.svg": 648,
	"./icon-sb-shop-more-160x106.svg": 576,
	"./icon-sb-shop-more-desktop.svg": 819,
	"./icon-sb-shop-more-mob.svg": 820,
	"./icon-sb-shop-more-tablet.svg": 821,
	"./icon-sb-shop-similar.svg": 546,
	"./icon-sb-shop-the-collection-48x48.svg": 616,
	"./icon-sb-shop-the-collection-boutique-48x48.svg": 617,
	"./icon-sb-star-filled.svg": 588,
	"./icon-sb-trash-16x16.svg": 618,
	"./icon-sb-trend.svg": 632,
	"./icon-sb-unbox-illustration.svg": 649,
	"./icon-sb-up-arrow-black.svg": 589,
	"./icon-sb-white-glove-160x106.svg": 577,
	"./icon-sb-white-glove-desktop.svg": 822,
	"./icon-sb-white-glove-mob.svg": 823,
	"./icon-sb-white-glove-tablet.svg": 824,
	"./icon-true-luxury.svg": 536,
	"./icon_sb_affirm_48x48.svg": 825,
	"./icon_sb_hand_truck_48x48.svg": 641,
	"./icon_sb_rating_alt_desktop.svg": 826,
	"./icon_sb_return_16x16.svg": 827,
	"./icon_sb_return_boutique_16x16.svg": 828,
	"./icon_sb_return_boutique_black_14x14_v1.svg": 829,
	"./icon_sb_return_boutique_black_14x14_v2.svg": 830,
	"./icon_sb_return_boutique_black_16x16.svg": 831,
	"./icon_sb_return_boutique_black_16x16_v1.svg": 619,
	"./icon_sb_shipping_16x16.svg": 832,
	"./icon_sb_shipping_18x13.svg": 833,
	"./icon_sb_shipping_18x13_v1.svg": 666,
	"./icon_sb_shipping_boutique_16x16.svg": 834,
	"./icon_sb_star_16.svg": 835,
	"./icon_sb_white_glove_16x16.svg": 836,
	"./icon_sb_white_glove_boutique_16x16.svg": 837,
	"./icon_sb_white_glove_diamond_16x16.svg": 838,
	"./icon_sb_white_glove_diamond_16x16_v1.svg": 839,
	"./icons/animation/1sb-loader_icon.svg": 572,
	"./icons/credit-card/icon-sb-cvv-32x32.svg": 578,
	"./illustrationicon-sb-ottoman-recliner-boutique-48x48.svg": 564,
	"./illustrationicon-sb-ottoman-recliner-boutique.svg": 565,
	"./images/guardian_full_img.svg": 667,
	"./logo-238x80.svg": 271,
	"./logo-gold-167x57.svg": 840,
	"./logo-white-167x57.svg": 642,
	"./logo.svg": 841,
	"./mattress-none-boutique.svg": 842,
	"./mattress-none.svg": 843,
	"./one_img_orange_tag.svg": 844,
	"./one_img_orange_tag_desktop_v1.svg": 845,
	"./onepage/affirm.svg": 537,
	"./onepage/american-express.svg": 538,
	"./onepage/discover.svg": 539,
	"./onepage/icon-sb-delete-address-illustration-200x200.svg": 520,
	"./onepage/katapult_payment_loan.svg": 540,
	"./onepage/mastercard.svg": 541,
	"./onepage/paypal_express.svg": 542,
	"./onepage/place-order-affirm.svg": 521,
	"./onepage/place-order-katapult.svg": 522,
	"./onepage/place-order-paypal.svg": 523,
	"./onepage/visa.svg": 543,
	"./placeholder-animation.svg": 516,
	"./president_tag_bg.svg": 846,
	"./reviews/1sb-dropdown.svg": 633,
	"./reviews/1sb_five_stars_selected_ekomi_d.svg": 847,
	"./reviews/1sb_five_stars_selected_google_d.svg": 848,
	"./reviews/1sb_five_stars_selected_reseller_d.svg": 849,
	"./reviews/1sb_five_stars_selected_reviews_d.svg": 850,
	"./reviews/1sb_five_stars_selected_shopper_d.svg": 851,
	"./reviews/1sb_five_stars_selected_sidejabber_d.svg": 852,
	"./reviews/1sb_five_stars_selected_trustpilot_d.svg": 853,
	"./reviews/1sb_five_stars_unselected_ekomi_d.svg": 854,
	"./reviews/1sb_five_stars_unselected_google_d.svg": 855,
	"./reviews/1sb_five_stars_unselected_reseller_d.svg": 856,
	"./reviews/1sb_five_stars_unselected_reviews_d.svg": 857,
	"./reviews/1sb_five_stars_unselected_shopper_d.svg": 858,
	"./reviews/1sb_five_stars_unselected_sidejabber_d.svg": 859,
	"./reviews/1sb_five_stars_unselected_trustpilot_d.svg": 860,
	"./reviews/icon-sb-checkmark-white-color-16.svg": 668,
	"./reviews/icon_sb_checkmark_green.svg": 566,
	"./reviews/icon_sb_rating_alt_desktop_v1.svg": 634,
	"./reviews/icon_sb_rating_alt_desktop_v2.svg": 635,
	"./reviews/icon_sb_rating_alt_mob_v1.svg": 636,
	"./reviews/icon_sb_select_star_ekomi_t.svg": 861,
	"./reviews/icon_sb_select_star_google_t.svg": 862,
	"./reviews/icon_sb_select_star_reseller_t.svg": 863,
	"./reviews/icon_sb_select_star_reviews_i_t.svg": 864,
	"./reviews/icon_sb_select_star_shopper_t.svg": 865,
	"./reviews/icon_sb_select_star_sitejabber_t.svg": 866,
	"./reviews/icon_sb_select_star_trustpilot_t.svg": 867,
	"./reviews/icon_sb_unselect_star_ekomi_t.svg": 868,
	"./reviews/icon_sb_unselect_star_google_t.svg": 869,
	"./reviews/icon_sb_unselect_star_reseller_t.svg": 870,
	"./reviews/icon_sb_unselect_star_reviews_i_t.svg": 871,
	"./reviews/icon_sb_unselect_star_shopper_t.svg": 872,
	"./reviews/icon_sb_unselect_star_sitejabber_t.svg": 873,
	"./reviews/icon_sb_unselect_star_trustpilot_t.svg": 874,
	"./reviews/review_banner_d.svg": 637,
	"./reviews/review_banner_m.svg": 643,
	"./reviews/review_banner_t.svg": 875,
	"./sb_ashley_tag.svg": 876,
	"./selected-checkbox.svg": 398,
	"./selected-checkbox_black-1.svg": 650,
	"./selected-checkbox_black.svg": 877,
	"./selected-checkbox_boutique.svg": 620,
	"./selected-colorGenBlack.svg": 669,
	"./selected-colorGenWhite.svg": 524,
	"./selected-disabled-checkbox.svg": 372,
	"./selected-radio_black.svg": 527,
	"./selected-radio_boutique.svg": 528,
	"./selected.svg": 396,
	"./sofa-img-v1.svg": 670,
	"./star_icon_16.svg": 878,
	"./table-sort-up.svg": 399,
	"./tag/1sb_mini_logo_white.svg": 544,
	"./tag/icon-sb-1sb_Mini_logo-16x16.svg": 545,
	"./tag/icon-sb-labor-day-bg.svg": 529,
	"./tag/icon-sb-star-filled.svg": 530,
	"./testimonials/1sb-dropdown.svg": 671,
	"./testimonials/1sb-five-stars-orange-five_new_v1.svg": 879,
	"./testimonials/1sb-five-stars-orange-new_mob.svg": 880,
	"./testimonials/icon-sb-chevron-down-blue-color.svg": 672,
	"./unselected-checkbox.svg": 380,
	"./unselected-checkbox_gray.svg": 881,
	"./unselected-disabled-checkbox.svg": 373,
	"./unselected-radio_black.svg": 531,
	"./unselected.svg": 397,
	"./widget-91x73.svg": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;